export default __webpack_public_path__ + "static/media/04-2.6fee4423.jpg";